export const criticalNoCallPrefix = 'critical-no-call_';
